// extracted by mini-css-extract-plugin
export var card = "styles-module--card--a4284";
export var cardDescription = "styles-module--card-description--df6ef";
export var cardIcon = "styles-module--card-icon--27e0b";
export var cardTitle = "styles-module--card-title--09ece";
export var cards = "styles-module--cards--b29b4";
export var firstGlow = "styles-module--first-glow--e3b43";
export var secondGlow = "styles-module--second-glow--48f85";